'use client'

import { useAgentAuthDetails, useUserAuthDetails } from '@repo/services'
import { useUserSync } from '../../hooks'
import { globalConfig } from '../..'

export const UserSyncProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { data: { data: authDetails } = {} } = globalConfig.isAgents
    ? useAgentAuthDetails()
    : useUserAuthDetails()
  const userId = authDetails?.id

  useUserSync(userId)

  return <>{children}</>
}
